import React, { useContext } from "react";
import AddIcon from "../../../shared/svg/AddIcon";
import { useNavigate } from "react-router-dom";
import {
    TitleWrapper,
    TitleText,
    StyledButton,
} from "../../../shared/styled/TitleBar";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";

const Title = () => {
    const navigate = useNavigate();
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canCreate = role === ROLE.MANAGER;

    const onClickAddButton = () => {
        navigate("/addons/create");
    };

    return (
        <TitleWrapper>
            <TitleText>Danh sách dịch vụ</TitleText>
            {canCreate && (
                <StyledButton variant="contained" onClick={onClickAddButton}>
                    <AddIcon />
                    Tạo mới dịch vụ
                </StyledButton>
            )}
        </TitleWrapper>
    );
};

export default Title;
